import { FC, useState } from "react";
import EmptyStar from "../Icons/EmptyStar";
import FilledStar from "../Icons/FilledStar";

interface StarRatingProps {
  rating: number;
  color?: string;
  onChange?: (value: number) => void;
  readonly?: boolean;
}

const StarRating: FC<StarRatingProps> = ({
  rating,
  color,
  onChange,
  readonly = true,
}) => {
  const maxStars = 5;
  const [hoveredStar, setHoveredStar] = useState<number | null>(null);

  const handleClick = (index: number) => {
    if (onChange) onChange(index + 1);
  };

  const handleMouseEnter = (index: number) => {
    if (!readonly) setHoveredStar(index);
  };

  const handleMouseLeave = () => {
    if (!readonly) setHoveredStar(null);
  };

  return (
    <div className="d-flex gap-3 align-items-center min-w-102px">
      {[...Array(maxStars)].map((_, i) => {
        const isFilled =
          hoveredStar !== null ? i <= hoveredStar : i < Math.floor(rating);
        const Star = isFilled ? FilledStar : EmptyStar;

        return (
          <div
            key={i}
            onClick={() => handleClick(i)}
            onMouseEnter={() => handleMouseEnter(i)}
            onMouseLeave={handleMouseLeave}
            className={`${!readonly ? "cursor-pointer" : ""}`}
          >
            <Star color={color} />
          </div>
        );
      })}
    </div>
  );
};

export default StarRating;
